import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import MoreVert from '@material-ui/icons/MoreVert';
import { withStyles } from '@material-ui/core/styles';

import commonStyles from './styles';

const styles = {
  icon: {
    ...commonStyles().icon,
  },
};

const OverflowMenuButton = ({
  classes,
  onClick,
}) => (
  <IconButton onClick={onClick} size="medium">
    <MoreVert className={`${classes.icon}`} />
  </IconButton>
);

OverflowMenuButton.propTypes = {
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

OverflowMenuButton.defaultProps = {
  onClick: () => {},
};

export default withStyles(styles)(OverflowMenuButton);
